// extracted by mini-css-extract-plugin
export var gif = "_jm-0";